export const SET_SEARCH_QUERY_PARTIES = "state/pages/parties/SET_SEARCH_QUERY_PARTIES";
export const SET_PARTIES_PAGE_NUMBER = "state/pages/parties/SET_PARTIES_PAGE_NUMBER";
